import React from "react";
import {
  FaCreditCard,
  FaTachometerAlt,
  FaProjectDiagram, FaChartPie, FaRadiation, FaBullseye, FaCoins, FaTree, FaClock, FaMap, FaChartArea, FaMicrophone,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import {FaCircleNodes, FaHandsBubbles, FaLetterboxd, FaSquarePollHorizontal, FaUserGroup} from "react-icons/fa6";

export const CardList = () => {
  const cards = [
    {
      title: "Credit Card",
      description: "Manage your credit card details securely.",
      icon: <FaCreditCard className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/credit-card",
    },
    {
      title: "Diagrams",
      description: "Visualize your data with diagrams.",
      icon: <FaProjectDiagram className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/diagrams",
    },
    {
      title: "Nodes",
      description: "Graph",
      icon: <FaCircleNodes className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/graph",
    },
    {
      title: "Bubble Chart",
      description: "Make a Bubble Chart",
      icon: <FaBullseye className="text-4xl text-blue-500" />,
      inProgress : true,
      link: "/bubblechart",
    },
    {
      title: "Pie Chart",
      description: "Make a Pie Chart",
      icon: <FaChartPie className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/piechart",
    },
    {
      title: "Radar Chart",
      description: "Make a Radar Chart",
      icon: <FaRadiation className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/radarchart",
    },
    {
      title: "Trading Chart",
      description: "Make a Chart with Trading Data",
      icon: <FaCoins className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/tradingChart",
    },
    {
      title: "Trading Trend",
      description: "Make a Chart with Trading Data",
      icon: <FaUserGroup className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/tradingTrend",
    },
    {
      title: "Heatmap Market Chart",
      description: "Make a Treemap Chart",
      icon: <FaTree className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/heatmapChart",
    },
    {
      title: "Treemap Chart",
      description: "Make a Treemap Chart",
      icon: <FaTree className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/treemapChart",
    },
    {
      title: "Area Chart",
      description: "Make a Area Chart",
      icon: <FaChartArea className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/areachart",
    },
    {
      title: "Veloster Chart",
      description: "Make a Veloster Chart",
      icon: <FaTachometerAlt className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/veloster",
    },
    {
      title: "KPI Chart",
      description: "Make a KPI Chart",
      icon: <FaTachometerAlt className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/kpichart",
    },
    {
      title: "Horizontal Chart",
      description: "Make a Horizontal Bar Chart",
      icon: <FaSquarePollHorizontal className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/horizontalbarchart",
    },
    {
      title: "Counter",
      description: "Make a count up component for your numbers!",
      icon: <FaClock className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/counter",
    },
    {
      title: "World Map",
      description: "Make a map dispertion of your data!",
      icon: <FaMap className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/worldmap",
    },
    {
      title: "Record Audio",
      description: "Record audio and get it in base64 format",
      icon: <FaMicrophone className="text-4xl text-blue-500" />,
      inProgress : false,
      link: "/recordaudio",
    },
  ];

  return (
    <div className="flex flex-col items-center py-10">
      <h2 className="text-3xl font-semibold mb-8">Components</h2>
      <div className="grid grid-cols-1  sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {cards.map((card, index) => (
            <Link
                to={card.link}
                key={index}
                className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm flex flex-col items-center hover:shadow-lg transition-shadow duration-300 ease-in-out"
            >
              {card.icon}
              <h3 className="text-xl font-bold mt-4">{card.title}</h3>
              <p className="text-gray-500 mt-2 text-center">{card.description}</p>
              {card.inProgress && <p className="text-red-500 mt-2 text-center">In Progress</p>}
            </Link>
        ))}
      </div>
    </div>
  );
};
